import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import snapshotCompareReducer from "./slices/snapshotCompareSlice";
import { baseApi } from "@/api/baseApi";

export const store = configureStore({
  reducer: {
    snapshotCompare: snapshotCompareReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(baseApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

setupListeners(store.dispatch);
